export enum FloorChoiceString {
    GROUND = "1",
    GROUND_WITH_GARDEN = "2",
    LOW_LEVELS = "3",
    HIGH_LEVELS = "4",
    LAST_LEVEL = "5",
    LAST_LEVEL_WITH_TERRACE = "6"
}
export enum FloorChoiceString {
    GROUND = "1",
    GROUND_WITH_GARDEN = "2",
    LOW_LEVELS = "3",
    HIGH_LEVELS = "4",
    LAST_LEVEL = "5",
    LAST_LEVEL_WITH_TERRACE = "6"
}
